import React from 'react';
import ExpenseBoard from '../components/ExpenseComps/ExpenseBoard';

const CONFIG = {
    noun: 'Other',
    categories: ['Repairs & Maintenance', 'Utilities', 'Software & Subscriptions', 'Marketing', 'Professional Fees', 'Other'],
    trackStatus: true,
    extraFields: [{ key: 'vendor', label: 'Vendor' }],
};

export { CONFIG as OTHER_CONFIG };

export default function OtherExpensesPage({ data }) {
    return <ExpenseBoard config={CONFIG} data={data} />;
}
